import { render, staticRenderFns } from "./DialogProjectForm.vue?vue&type=template&id=45376c60&scoped=true&"
import script from "./DialogProjectForm.vue?vue&type=script&lang=js&"
export * from "./DialogProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./DialogProjectForm.vue?vue&type=style&index=0&id=45376c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45376c60",
  null
  
)

export default component.exports